import React from 'react';
import cx from 'classnames';

// TODO invoke iconAccessibility on svg tag like other existing icons do
import iconAccessibility from '../utils/iconAccessibility';
import styles from './Icons.module.scss';

export interface Props {
  accessibilityLabel?: string;
  className?: Parameters<typeof cx>[0];
}

export const ChevronLeftDoubleS1: React.FC<Props> = ({
  accessibilityLabel,
  className,
}) => (
  <i className={cx(styles.icon, className)}>
    <svg
      width='24'
      height='24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...iconAccessibility(accessibilityLabel)}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='m11.47 6.47 1.06 1.06L8.06 12l4.47 4.47-1.06 1.06L5.94 12l5.53-5.53Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='m16.47 6.47 1.06 1.06L13.06 12l4.47 4.47-1.06 1.06L10.94 12l5.53-5.53Z'
        fill='currentColor'
      />
    </svg>
  </i>
);

ChevronLeftDoubleS1.displayName = 'ChevronLeftDoubleS1';
export default ChevronLeftDoubleS1;
